import { Button } from '@/app/common/components/button/Button'
import { CircleLoader } from '@/common/components/CircleLoader.tsx'
import { cn } from '@/common/utilities.ts'
import { MutationStatus } from '@tanstack/react-query'
import { ButtonHTMLAttributes } from 'react'
import { ButtonVariant } from './button/buttonVariants'

type Props = {
  status: MutationStatus
  forceDisabled?: boolean
  buttonTxt?: string | React.ReactNode
  submittingText?: string
  type?: 'button' | 'submit'
  variant?: ButtonVariant['variant']
  size?: ButtonVariant['size']
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'id' | 'disabled' | 'type'>

export function SubmitButton({
  status,
  forceDisabled,
  className,
  size = 'lg',
  variant = 'primary',
  buttonTxt = 'Continue',
  submittingText = 'Submitting...',
  type = 'submit',
  ...props
}: Props) {
  const isSubmitting = status === 'pending'
  return (
    <Button
      disabled={isSubmitting || forceDisabled}
      className={cn(
        'w-full disabled:bg-gray-200 transtion-all duration-300 disabled:text-gray-600',
        className
      )}
      type={type}
      variant={variant}
      size={size}
      {...props}
    >
      {isSubmitting ? (
        <span className="flex gap-1 items-center">
          <CircleLoader size="sm" className="mr-1" />
          {submittingText}
        </span>
      ) : (
        <>{buttonTxt ?? 'Continue'}</>
      )}
    </Button>
  )
}
